import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";
import { Controller } from "react-hook-form";
import React from 'react';
import Error from '../Error';
function Confirmation({ control, errors, tenant }) {
    return (
        <div className="container">
            <div className="row">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Controller
                        name="agreement"
                        control={control}
                        rules={{ required: true }}
                        defaultValue={false}
                        render={({ field }) => (
                            <CheckBoxComponent
                                change={(args) => field.onChange(args.checked)}
                                checked={field.value}
                            />
                        )}
                    />

                    <label style={{ marginLeft: '10px', marginRight: '10px' }}>
                        <React.Fragment>
                            By submitting information you are agreeing to the processing of data in accordance with <a href="/privacypolicy" target="_blank">CPA</a> privacy policy
                        </React.Fragment>

                        {tenant && tenant.privacyPolicyUrl !== '' && (
                            <React.Fragment>
                                &nbsp;and the privacy policy of <a href={tenant.privacyPolicyUrl} target="_blank">{tenant.shortName !== '' ? tenant.shortName : tenant.name}</a>
                            </React.Fragment>
                        )}.
                    </label>

                </div>
            </div>

            {errors.agreement && <Error>* Your agreement is required</Error>}
        </div>
  );
}

export default Confirmation;